import { isInvestCompany } from "helpers/AuthType/company_helper";

const isInvest = isInvestCompany();

export const RTL_LANGUAGES = ["ar", "ar-SA", "ur", "ur-PK"];

const languages = [
  {
    $id: "1",
    id: 1,
    languageCode: "en-US",
    culture: "en-US",
    languageTitle: "English",
  },
  {
    $id: "2",
    id: 2,
    languageCode: "zh-CN",
    culture: "zh-CN",
    languageTitle: "Chinese",
  },
  {
    $id: "3",
    id: 3,
    languageCode: "TW",
    culture: "zh-TW",
    languageTitle: "Taiwanese",
  },
  {
    $id: "4",
    id: 4,
    languageCode: "HI",
    culture: "hi-IN",
    languageTitle: "Hindi",
  },
  {
    $id: "5",
    id: 5,
    languageCode: "th",
    culture: "th-TH",
    languageTitle: "Thai",
  },
  {
    $id: "6",
    id: 6,
    languageCode: "vi-VN",
    culture: "vi-VN",
    languageTitle: "Vietnamese",
  },
  {
    $id: "7",
    id: 7,
    languageCode: "KR",
    culture: "ko-KR",
    languageTitle: "Korean",
  },
  {
    $id: "8",
    id: 8,
    languageCode: "tl-PH",
    culture: "en-PH",
    languageTitle: "Filipino",
  },
  {
    $id: "9",
    id: 9,
    languageCode: "es-ES",
    culture: "es-ES",
    languageTitle: "Spanish",
  },
  {
    $id: "10",
    id: 10,
    languageCode: "ja-JP",
    culture: "ja-JP",
    languageTitle: "Japanese",
  },
  // {
  //   $id: "11",
  //   id: 11,
  //   languageCode: "ur-PK",
  //   culture: "ur-PK",
  //   languageTitle: "Pakistan",
  // },
  {
    $id: "12",
    id: 12,
    languageCode: "id-IN",
    culture: "id-IN",
    languageTitle: "Indonesian",
  },
];

const filteredLanguages = languages.filter((lang) => {
  if (lang.languageCode === "en-US") {
    return true;
  }
  if (isInvest) {
    return lang.languageCode === "id-IN";
  } else {
    return lang.languageCode !== "id-IN";
  }
});

export default filteredLanguages;
